import { FaClock, FaChartLine, FaBookOpen, FaMoneyBill, FaHandsHelping, FaArrowUp } from 'react-icons/fa';
import { images } from '../constants'; 

const careerIntro = {
    sub: "Join Our Team",
    heading: "Join the Flooring Installation Team Today",
    description: "At Flooring Installation Services, we're looking for dedicated individuals to become part of our team. Explore exciting career opportunities in flooring installation and paving services. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
    points: [
        "Opportunities in Flooring Installation",
        "Assist in Tiling Operations",
        "Advanced Paving Training Programs",
        "Tiling Situation Management",
        "Support in Flooring Safety Measures",
    ],
    image: {
        src: images.careerIntro,
        alt: "Career-Image",
    },
};


const benefits = [
    {
        id: 1,
        icon: <FaChartLine />,
        title: "Career Advancement",
        description: "Explore abundant opportunities for career growth and advancement within the flooring, tiling, and paving services industry.",
    },
    {
        id: 2,
        icon: <FaBookOpen />,
        title: "Training Programs",
        description: "Participate in comprehensive training programs tailored to enhance your skills in flooring installation, tiling, and paving, ensuring proficiency in various techniques and methods.",
    },
    {
        id: 3,
        icon: <FaMoneyBill />,
        title: "Competitive Pay",
        description: "Enjoy attractive pay packages and benefits in the flooring, tiling, and paving services sector, ensuring financial stability and security.",
    },
    {
        id: 4,
        icon: <FaClock />,
        title: "Flexible Hours",
        description: "Benefit from flexible working hours designed to accommodate your personal commitments and lifestyle preferences, promoting work-life balance.",
    },
    {
        id: 5,
        icon: <FaHandsHelping />,
        title: "Team Support",
        description: "Experience a collaborative and supportive team environment within the flooring, tiling, and paving services industry, fostering camaraderie and mutual growth.",
    },
    {
        id: 6,
        icon: <FaArrowUp />,
        title: "Growth Potential",
        description: "Unlock vast opportunities for personal and professional growth, with ample room for advancement and skill development in the dynamic industry landscape.",
    },
];


const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Flooring Installer',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Flooring Installation',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are seeking experienced Flooring Installers to join our professional team. As a Flooring Installer, you will be responsible for accurate and durable installation of various flooring types. Candidates should have a strong work ethic, great attention to detail, and the ability to work independently and as part of a team.',
        ],
        responsibilities: [
            'Installing residential and commercial flooring with precision.',
            'Measuring, cutting, and laying flooring materials accurately.',
            'Preparing subfloors and applying adhesives or fasteners.',
            'Following safety protocols and maintaining clean work areas.',
            'Identifying and resolving flooring installation challenges.',
            'Collaborating with team members and project supervisors.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in flooring installation.',
            'Familiarity with tools and materials used in flooring work.',
            'Physical ability to handle heavy materials and work on feet.',
            'Commitment to safety, quality standards, and customer satisfaction.',
            'Strong communication and problem-solving abilities.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Tiling Specialist',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Tiling Work',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are looking for skilled Tiling Specialists to join our growing team. As a Tiling Specialist, you will be responsible for installing and finishing tiles with precision and craftsmanship. The ideal candidate should have strong technical skills, a good eye for detail, and a commitment to delivering high-quality results.',
        ],
        responsibilities: [
            'Measuring and cutting tiles to fit designated spaces accurately.',
            'Installing ceramic, porcelain, and natural stone tiles on floors and walls.',
            'Applying grout and ensuring smooth, level finishes.',
            'Inspecting and preparing surfaces before tiling.',
            'Maintaining clean and safe work environments.',
            'Working collaboratively with team members and site managers.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of hands-on experience in tiling.',
            'Knowledge of various tiling materials and installation techniques.',
            'Ability to lift and handle heavy tiles and tools.',
            'Commitment to quality, precision, and safety standards.',
            'Effective communication and problem-solving skills.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Paving Technician',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Paving Services',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are hiring experienced Paving Technicians to join our paving services division. As a Paving Technician, you will be responsible for the precise laying and finishing of various paving materials. Candidates must be detail-oriented, safety-conscious, and capable of working efficiently in a team setting.',
        ],
        responsibilities: [
            'Preparing surfaces for paving by grading and compacting soil or gravel.',
            'Installing asphalt, concrete, and stone paving materials. ',
            'Ensuring accurate alignment, level, and spacing of paving materials.',
            'Operating paving tools and machinery safely and effectively.',
            'Conducting finishing work such as sealing and edge trimming.',
            'Working closely with supervisors and construction crews to complete projects on time.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in paving services.',
            'Familiarity with paving equipment and tools.',
            'Ability to work outdoors in varying weather conditions.',
            'Strong attention to safety, durability, and workmanship.',
            'Good teamwork, time management, and communication skills.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Flooring Consultant',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Flooring Consultation or Sales',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are seeking a knowledgeable and customer-focused Flooring Consultant to guide clients through flooring solutions. In this role, you will assist customers in choosing the right flooring products based on their needs, preferences, and budget while providing excellent service and professional advice.',
        ],
        responsibilities: [
            'Advising customers on flooring materials, styles, and installation options.',
            'Preparing estimates and product recommendations based on site conditions and client preferences.',
            'Maintaining a well-organized and visually appealing showroom.',
            'Coordinating with installation teams to ensure customer satisfaction.',
            'Building lasting relationships with clients through follow-ups and support.',
            'Keeping up-to-date with industry trends, materials, and techniques.',
        ],
        qualifications: [
            'High school diploma or equivalent; associate’s degree preferred.',
            'Minimum 3 years of experience in flooring consultation or related sales roles.',
            'Strong product knowledge of various flooring types and installation practices.',
            'Excellent interpersonal, negotiation, and communication skills.',
            'Attention to detail and a customer-first mindset.',
            'Proficiency with sales software and CRM tools is a plus.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Tiling Technician',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Tiling Services',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are hiring skilled Tiling Technicians to join our installation crew. As a Tiling Technician, you’ll be responsible for installing various tile surfaces with precision and efficiency in both residential and commercial spaces. The role requires attention to detail, strong craftsmanship, and an understanding of materials and techniques.',
        ],
        responsibilities: [
            'Measuring and marking surfaces to lay out work. ',
            'Cutting tiles and arranging patterns to fit spaces perfectly.',
            'Applying adhesives and grouts properly for lasting results.',
            'Ensuring surface cleanliness, alignment, and durability.',
            'Working with a variety of tile types including ceramic, porcelain, and stone.',
            'Maintaining safety standards and clean job sites.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in tile installation.',
            'Proficiency in cutting, setting, and finishing tiles.',
            'Familiarity with tools, adhesives, and leveling systems.',
            'Strong physical stamina and attention to detail.',
            'Good communication and teamwork skills.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Paving Specialist',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Shifts',
            experience: 'Minimum 3 Years in Paving Services',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$60K - $75K',
            deadline: 'Apply Now - Open Until Filled',
            number: 'For Assistance: Call 123-456-7890',
        },
        overviews: [
            'We are currently seeking experienced Paving Specialists to join our dedicated crew. As a Paving Specialist, your role involves preparing surfaces, laying paving materials, and ensuring quality finishes in both residential and commercial projects. This position requires strong physical ability, precision, and a solid understanding of paving techniques.',
        ],
        responsibilities: [
            'Preparing surfaces by cleaning, grading, and compacting. ',
            'Laying asphalt, concrete, or other paving materials accurately.',
            'Operating paving and compaction equipment safely.',
            'Following project blueprints and specifications closely.',
            'Ensuring even surfaces and durable results.',
            'Collaborating with team members and supervisors to meet deadlines.',
        ],
        qualifications: [
            'High school diploma or equivalent.',
            'Minimum 3 years of experience in paving or related work.',
            'Knowledge of paving equipment and safety practices.',
            'Physical strength and endurance for outdoor work.',
            'Attention to detail and a commitment to quality.',
            'Strong communication and teamwork skills.',
        ],
    }

];

export { positions, benefits, careerIntro };